import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export const TopListingNotification = () => {
  const { t } = useTranslation();
  return (
    <Box mt={2} fontSize="md" py={2} px={4} borderRadius="md" bgColor="gray.100">
      {t('products.createModal.topListing.notification')}
    </Box>
  );
};
